import { useState, useEffect } from 'react'
import { clientService } from '../services/clientService'
import type { Client, ClientStatus } from '../types'

export function useClient(id: number) {
  const [data, setData] = useState<Client | null>(null)
  const [status, setStatus] = useState<ClientStatus | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      setError(null)
      try {
        const [client, clientStatus] = await Promise.all([
          clientService.getById(id),
          clientService.getStatus(id),
        ])
        setData(client)
        setStatus(clientStatus)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Error al cargar cliente')
      } finally {
        setIsLoading(false)
      }
    }
    fetchData()
  }, [id])

  return { data, status, isLoading, error }
}
